import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import _ from 'lodash';
import MetadataAttribute from './MetadataAttribute';

import './style.scss';

const Metadata = ({ metadataAttributes }) => {
    const validAttributes = _.compact(metadataAttributes);

    if (!(validAttributes.length > 0)) {
        return null;
    }

    return (
        <ul className="metadata">
            {
                validAttributes.map(({ name, options }) => (
                    <MetadataAttribute key={name} name={name} options={options}/>
                ))
            }
        </ul>
    );
};

Metadata.propTypes = {
    metadataAttributes: arrayOf(
        shape({
            name: string,
            options: arrayOf(string)
        })
    ).isRequired
};

export default Metadata;
